import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { DeliveryPackage } from '../../model/deliveryPackage';
import { DataNavigation } from '../../util/dataNavigation';
import { Router } from '@angular/router';
import { DeliveryPackageService } from '../../service/delivery-package.service';
import { ConfirmPopupComponent } from '../../dialog/confirm-popup/confirm-popup.component';
import { NbDialogService } from '@nebular/theme';
import { TranslateService } from '@ngx-translate/core';
import { DeliverOrderComponent } from '../deliver-order/deliver-order.component';
import { UserRoles } from '../../model/userRoles';
import { ImageViewComponent } from '../../dialog/image-view/image-view.component';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'delivery-package-card-slim',
  templateUrl: './delivery-package-card-slim.component.html',
  styleUrls: ['./delivery-package-card-slim.component.css']
})
export class DeliveryPackageCardSlimComponent implements OnInit {
  constructor(
    private sanitizer: DomSanitizer,
    private dialogService: NbDialogService,
    private modalservice: BsModalService, 
    private dataNavigation: DataNavigation, 
    protected router: Router, 
    private deliveryPackageService: DeliveryPackageService,
    private translate: TranslateService) { }

  modalRef: BsModalRef;
  public managerRole: string = UserRoles.manager;
  public operatorRole: string = UserRoles.operator;
  public userRole: string = UserRoles.user;

  @Input() deliveryPackage: DeliveryPackage;
  @Input() role: string;
  @Output() orderDelivered: EventEmitter<any> = new EventEmitter()

  ngOnInit(): void {}

  cardClicked() {
    if (this.role == this.managerRole || this.role == this.operatorRole) {
      this.dialogService.open(DeliverOrderComponent, {
        context: { deliveryPackage: this.deliveryPackage }
      }).onClose.subscribe(deliveryCompleted => {
        this.orderDelivered.emit(deliveryCompleted);
        console.log(deliveryCompleted);
      });
    }
    else {
      this.receiveClicked();
    }
  }

  editClicked() {
    this.dataNavigation.SelectedDeliveryPackage = this.deliveryPackage;
    this.router.navigate(["pages/register-package"]);
  }

  deleteClicked() {
    this.dialogService.open(ConfirmPopupComponent, {
      context: {
        title: `${this.translate.instant("DELIVERY_PACKAGE.PAGE.DELIVERY_PACKAGE_CARD_SLIM.ALERTS.DELETE_ORDER")}\n ${this.deliveryPackage.ownerUserName}`,
      }
    })
      .onClose.subscribe(confirm => {
        if (confirm) {
          this.deliveryPackageService.deletePackage(this.deliveryPackage.id).subscribe();
          this.router.navigate(["pages/delivery-package"]);
        }
      })
    
  }

  receiveClicked() {
    this.deliveryPackageService.getDeliveryPackageQrCode(this.deliveryPackage.id).subscribe(
      qrCode => {
        if (qrCode) {
          const objectUrl = URL.createObjectURL(qrCode);
          var qrCodeUrl = this.sanitizer.bypassSecurityTrustUrl(objectUrl)
          this.dialogService.open(ImageViewComponent, {
            context: {
              title: this.translate.instant("DELIVERY_PACKAGE.PAGE.PRESENT_QRCODE_TO_RECEIVE"),
              imageUrl: qrCodeUrl
            }
          })
          .onClose.subscribe(() => {
            this.router.navigate(["pages/delivery-package"]);
          });
        }
      },
      error => { }
    );
    
  }
}
